export class AiModelConstants {
  static getLanguages() {
    return [
      { label: "English", value: "English" },
      { label: "French", value: "French" },
      { label: "Spanish", value: "Spanish" },
      { label: "German", value: "German" },
      { label: "Italian", value: "Italian" },
      { label: "Dutch", value: "Dutch" },
      { label: "Swedish", value: "Swedish" },
      { label: "Czech", value: "Czech" },
      { label: "Turkish", value: "Turkish" },
      { label: "Russian", value: "Russian" },
      { label: "Greek", value: "Greek" },
      { label: "Hungarian", value: "Hungarian" },
      { label: "Irish", value: "Irish" },
      { label: "Japanese", value: "Japanese" },
      { label: "Korean", value: "Korean" },
      { label: "Chinese, Simplified", value: "Chinese, Simplified" },
      { label: "Chinese, Traditional", value: "Chinese, Traditional" },
      { label: "Malay", value: "Malay" },
      { label: "Indonesian", value: "Indonesian" },
      { label: "Thai", value: "Thai" },
      { label: "Vietnamese", value: "Vietnamese" },
      { label: "Filipino", value: "Filipino" },
      { label: "Khmer", value: "Khmer" },
      { label: "Hindi", value: "Hindi" },
      { label: "Tamil", value: "Tamil" },
      { label: "Kazakh", value: "Kazakh" },
      { label: "Polish", value: "Polish" },
      { label: "Portuguese", value: "Portuguese" },
      { label: "Arabic", value: "Arabic" },
      { label: "Afrikaans", value: "Afrikaans" },
      { label: "Swahili", value: "Swahili" },
    ];
  }

  static getGrades() {
    return [
      { label: 'Pre-K', value: 'Pre-K' },
      { label: 'Kindergarten', value: 'Kindergarten' },
      { label: '1st Grade', value: '1st Grade' },
      { label: '2nd Grade', value: '2nd Grade' },
      { label: '3rd Grade', value: '3rd Grade' },
      { label: '4th Grade', value: '4th Grade' },
      { label: '5th Grade', value: '5th Grade' },
      { label: '6th Grade', value: '6th Grade' },
      { label: '7th Grade', value: '7th Grade' },
      { label: '8th Grade', value: '8th Grade' },
      { label: '9th Grade', value: '9th Grade' },
      { label: '10th Grade', value: '10th Grade' },
      { label: '11th Grade', value: '11th Grade' },
      { label: '12th Grade', value: '12th Grade' },
      { label: 'Year 1', value: 'Year 1' },
      { label: 'Year 2', value: 'Year 2' },
      { label: 'Year 3', value: 'Year 3' },
      { label: 'Year 4', value: 'Year 4' },
      { label: 'Year 5', value: 'Year 5' },
      { label: 'Year 6', value: 'Year 6' },
      { label: 'Year 7', value: 'Year 7' },
      { label: 'Year 8', value: 'Year 8' },
      { label: 'Year 9', value: 'Year 9' },
      { label: 'Year 10', value: 'Year 10' },
      { label: 'Year 11', value: 'Year 11' },
      { label: 'Year 12', value: 'Year 12' },
      { label: 'Year 13', value: 'Year 13' },
      { label: 'University', value: 'University' },
    ];
  }

  static getCountries() {
    return [
      {label: "United State of America", value: "United State of America"},
      {label: "United Kingdom", value: "United Kingdom"},
      {label: "Canada", value: "Canada"},
      {label: "Australia", value: "Australia"},
      {label: "New Zealand", value: "New Zealand"},
      {label: "Mexico", value: "Mexico"},
      {label: "Colombia", value: "Colombia"},
      {label: "Brazil", value: "Brazil"},
      {label: "Argentina", value: "Argentina"},
      {label: "Puerto Rico", value: "Puerto Rico"},
      {label: "France", value: "France"},
      {label: "Italy", value: "Italy"},
      {label: "Spain", value: "Spain"},
      {label: "Germany", value: "Germany"},
      {label: "Poland", value: "Poland"},
      {label: "Austria", value: "Austria"},
      {label: "Netherlands", value: "Netherlands"},
      {label: "Belgium", value: "Belgium"},
      {label: "Greece", value: "Greece"},
      {label: "Sweden", value: "Sweden"},
      {label: "Switzerland", value: "Switzerland"},
      {label: "Hungary", value: "Hungary"},
      {label: "Turkiye", value: "Turkiye"},
      {label: "Russia", value: "Russia"},
      {label: "Saudi Arabia", value: "Saudi Arabia"},
      {label: "Qatar", value: "Qatar"},
      {label: "UAE", value: "UAE"},
      {label: "Singapore", value: "Singapore"},
      {label: "Malaysia", value: "Malaysia"},
      {label: "Indonesia", value: "Indonesia"},
      {label: "Thailand", value: "Thailand"},
      {label: "Vietnam", value: "Vietnam"},
      {label: "Philippines", value: "Philippines"},
      {label: "Cambodia", value: "Cambodia"},
      {label: "Japan", value: "Japan"},
      {label: "Korea", value: "Korea"},
      {label: "Hong Kong", value: "Hong Kong"},
      {label: "Taiwan", value: "Taiwan"},
      {label: "China", value: "China"},
      {label: "Brunei", value: "Brunei"},
    ]
  }

  static getCEFROptions() {
    return [
      "A1 - Beginner: Basic words and phrases; can introduce themselves and answer simple questions",
      "A2 - Elementary: Simple conversations; can handle basic daily interactions and familiar topics",
      "B1 - Intermediate: Everyday talk; can discuss personal interests and handle most travel situations",
      "B2 - Upper Intermediate: Detailed discussions; can express opinions and debate topics spontaneously",
      "C1 - Advanced: Advanced understanding; can understand nuanced language and express ideas fluently",
      "C2 - Mastery: Near-native level; can use the language with full flexibility and precision"];
  }
}